import { render } from "./assessment-panel--history-inactive.vue?vue&type=template&id=7e432784&scoped=true&ts=true"
import script from "./assessment-panel--history-inactive.vue?vue&type=script&lang=ts"
export * from "./assessment-panel--history-inactive.vue?vue&type=script&lang=ts"

import "./assessment-panel--history-inactive.vue?vue&type=style&index=0&id=7e432784&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e432784"]])

export default __exports__